import { render, staticRenderFns } from "./AccordionWrap.vue?vue&type=template&id=c440a118&scoped=true"
import script from "./AccordionWrap.vue?vue&type=script&lang=ts"
export * from "./AccordionWrap.vue?vue&type=script&lang=ts"
import style0 from "./AccordionWrap.vue?vue&type=style&index=0&id=c440a118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c440a118",
  null
  
)

export default component.exports